import * as React from 'react'

import { parseDate } from '@/utils/dateFormat'

import { SittingReportStep3 as Presenter } from './presenter'
import { buildReserveOption } from '@/apis/reserves'

interface IProps {
  isTokyoBsWaiting?: boolean
  isTokyoBsTmpUse?: boolean
  isReportBack?: boolean
  user: IUser
  additionalChildOption?: IAdditionalChildOption
  formAuthenticityToken: string
  reserve: IReserveSummary
  options: IOption[]
  startAt: string
  endAt: string
  optionDetails: IReservePriceDetail[]
  optionText: string
  totalPrice: number
  extendTotal: number
  extendReason: string
  transportation: string
  schedule: string
  childrenMood: string
  comment: string
  messageOnReportInputLong: string
  editSupportDateUrl: string
  editPriceUrl: string
  editReportUrl: string
  editScheduleUrl: string
  editChildrenMoodUrl: string
  editCommentUrl: string
  editTokyoBsTmpUseUrl: string
  submitUrl: string
  backUrl: string
  showSittingPhotos: boolean
  sittingPhotos?: ISittingPhoto[]
}

const convertToReserveSittingPhoto = (
  reserve: IReserveSummary,
  photo: ISittingPhoto,
): IReserveSittingPhoto => {
  return {
    url: photo.image.thumb.url,
    slug: photo.slug,
    editUrl: `/schedules/${reserve.slug}/sitting_photo/${photo.slug}/caption?s=1`,
    caption: photo.caption,
    takenAt: parseDate(photo.taken_at),
  }
}

export const SittingReportStep3 = (props: IProps): JSX.Element => {
  const {
    formAuthenticityToken,
    additionalChildOption,
    reserve,
    options,
    startAt,
    endAt,
    optionDetails,
    optionText,
    totalPrice,
    extendTotal,
    extendReason,
    transportation,
    schedule,
    childrenMood,
    comment,
    editSupportDateUrl,
    editPriceUrl,
    editReportUrl,
    editScheduleUrl,
    editChildrenMoodUrl,
    editCommentUrl,
    editTokyoBsTmpUseUrl,
    submitUrl,
    backUrl,
    sittingPhotos,
  } = props

  const priceDetails: IReservePriceDetail[] = optionDetails

  const priceDetailsString = priceDetails
    .map((detail) => detail.toString())
    .join(', ')
  const photos = sittingPhotos.map((photo) =>
    convertToReserveSittingPhoto(reserve, photo),
  )
  const initOptions = options.map((option) => buildReserveOption(option))

  const args = {
    options: JSON.stringify(initOptions),
    priceDetails,
    startAt,
    endAt,
    priceDetailsString,
    additionalChildOption,
    optionText,
    transportation,
    schedule,
    childrenMood,
    comment,
    editSupportDateUrl,
    editPriceUrl,
    editReportUrl,
    editScheduleUrl,
    editChildrenMoodUrl,
    editCommentUrl,
    editTokyoBsTmpUseUrl,
    submitUrl,
    backUrl,
    totalPrice,
    extendTotal,
    extendReason,
    sittingPhotos: photos,
  }

  return <Presenter {...props} {...args} />
}
